import React, { useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";
import { inject, observer } from "mobx-react";

const PrivateRoute = inject("userStore")(
  observer(({ path, component, userStore }: any) => {
    const history = useHistory();
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
      // Give the UserStore a moment to validate the token
      const timeoutId = setTimeout(() => {
        const hasUser = localStorage.getItem("user");
        const hasToken = localStorage.getItem("mohren_token");

        if (!hasUser || !hasToken) {
          console.log("🔒 No valid authentication found, redirecting to login");
          localStorage.removeItem("user");
          localStorage.removeItem("mohren_token");
          history.push("/");
        }

        setIsChecking(false);
      }, 100); // Small delay to allow UserStore validation

      return () => clearTimeout(timeoutId);
    }, [history]);

    // Show nothing while checking authentication
    if (isChecking) {
      return <div></div>;
    }

    return (
      <div className="parent">
        <div className="container">
          <Route path={path} component={component} />
        </div>
      </div>
    );
  })
);

export default PrivateRoute;
